export default {
  // Este componente usa etiquetas dinâmicas de props (channelName)
  // Não há strings estáticas traduzíveis
}
